const module = { name: 'Fandango/share', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_context } from 'require-core';

let { context: { config } } = Fandango_context;


import { default as $ } from 'swug-fdRequire-call:jQuery';



const Selectors = {
    CONTAINER: '.js-share',
    SHARE_BTN: '.js-share-click',
    BTN_LIST: '.js-share-network'
}


const RegExes = {
    ALPHA_ONLY: /[^a-z0-9]/gi,
    PHOTO_PARAM: /(?:[/?&]|^)photoid=\d+/i
}


const Styles = {
    HIDDEN: 'share-button__item--hidden'
}


const NL = encodeURIComponent('\r\n')


let shareContent = {}


let campaign = false


let popCount = 0
function qsConcat(url, params) {
    if (typeof params === 'object') {
        params = $.param(params);
    }
    return url + (url.indexOf('?') < 0 ? '?' : '&') + params;
}
function getBaseUrl(photoId, network, shareUrl) {
    let url = shareUrl;
    if (!url) {
        url = window.location.href;
        const qs = (config && config.share && config.share.qs) || {};
        if (photoId) {
            qs.photoid = photoId;
        }
        if (qs.photoid) {
            url = url.replace(RegExes.PHOTO_PARAM, '');
        }
        url = qsConcat(url, qs);
    }
    if (campaign) {
        url = qsConcat(url, {
            intcmp: campaign + '_' + network.replace(RegExes.ALPHA_ONLY, '')
        });
    }
    return encodeURIComponent(url);
}
function initShareContent() {
    const defaultContent = {
        description: $('meta[name="description"]').attr('content'),
        photo: $('meta[property="og:image"]').attr('content'),
        photoId: '',
        shareUrl: $('meta[property="og:url"]').attr('content') || false,
        title: ($('title').text() || '').replace(/\s*[-|:]\s*fandango$/i, '')
    };
    updateShareContent(defaultContent);
}
function updateShareContent(newContent) {
    shareContent = $.extend({}, shareContent, newContent);
}
function getShareUrl(network) {
    const content = shareContent;
    let url = getBaseUrl(content.photoId, network, content.shareUrl);
    switch (network) {
        case 'pinterest':
            url += '&media=' + content.photo + '&description=' + content.description;
            break;
        case 'twitter':
            url += '&text=' + content.title + ' %23Fandango';
            break;
        case 'email':
            url = 'mailto:?subject=' + encodeURIComponent(content.title) + '&body=Article:%20' + url + NL + NL + content.description;
            break;
        case 'tumblr':
            if (content.photo) {
                url += '&posttype=photo&content=' + content.photo;
            }
            else {
                url += '&posttype=link&title=' + encodeURIComponent(content.title);
            }
            url += '&caption=' + encodeURIComponent(content.description) + '&tags=Fandango';
            break;
    }
    return url;
}
function networkBtnClicked(e) {
    const $this = $(this);
    const network = $this.data('sharedNetwork');
    const href = $this.attr('href');
    const height = 500;
    const width = 700;
    const left = (screen.width / 2) - (width / 2);
    const top = (screen.height / 2) - (height / 2);
    if (network === 'email') {
        $this.attr('href', getShareUrl(network));
        return true;
    }
    e.preventDefault();
    e.stopPropagation();
    popCount++;
    const url = href + getShareUrl(network);
    const windowName = 'sharePopup_' + popCount;
    const windowFeatures = `width=${width},height=${height},top=${top},left=${left}`;
    window.open(url, windowName, windowFeatures);
}
function setCampaign(value) {
    campaign = value;
}
function shareBtnClicked(e) {
    e.preventDefault();
    e.stopPropagation();
    const $parent = $(this).closest(Selectors.CONTAINER);
    if ($parent.hasClass('active')) {
        deactivateNetworkBtns();
        $('body').off('touchend click', deactivateNetworkBtns);
    }
    else {
        $parent.addClass('active');
        $('body').one('touchend click', deactivateNetworkBtns);
    }
}
function filterNetworks(networks) {
    $(Selectors.BTN_LIST)
        .find('[data-shared-network]')
        .each((index, element) => {
        const $element = $(element);
        const network = $element.data('sharedNetwork');
        if (networks.indexOf(network) < 0) {
            $element.parent('li').addClass(Styles.HIDDEN);
        }
    });
}
function deactivateNetworkBtns() {
    $(Selectors.CONTAINER).removeClass('active');
}
function init() {
    initShareContent();
    $(Selectors.SHARE_BTN).on('touchend click', shareBtnClicked);
    $(Selectors.BTN_LIST).on('touchend click', 'a', networkBtnClicked);
}
module.exports = {
    __reinit__(testConfigs) {
        config = testConfigs;
        shareContent = {};
        campaign = false;
        popCount = 0;
        init();
    },
    init,
    updateShareContent,
    setCampaign,
    filterNetworks,
};
export default module.exports;